<template>
<div class="container ">
  <v-card
    class="mx-auto m4u_tertiary"
    :width ="$vuetify.breakpoint.xs ? '70vw' : '40vw'"
  >
    <v-card-text class="m4u_text--text">

      <h3 >
        <img v-if="book.TimeCapsuleDate === null" src="@/assets/bookbackground.png" width="30px">
        <img v-if="book.TimeCapsuleDate !== null" src="@/assets/hourglass.png" width="30px">
       {{book.BookTitle}}, {{book.UserDisplayName}} 
        <v-btn
        text
        color="teal accent-4"
        @click="getBookContent(book.BookID)"
      >

        <v-icon large v-if="!reveal">mdi-chevron-down</v-icon>
         <v-icon large v-if="reveal">mdi-chevron-up</v-icon>
      </v-btn>
       
      </h3>



    </v-card-text>

    <v-expand-transition>
      <v-card
        v-if="reveal === true"
        class="transition-fast-in-fast-out v-card--reveal m4u_tertiary"
        style="height: 100%;"
      >
        <v-card-text>
                 <!---BEGINNING OF EDIT DIALOG --->

    <v-dialog
    v-if="book.BookOwner === user.UserID"
      v-model="dialogedit"
      persistent
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          icon
          @click="startEdit()"
        >
      <v-icon class="m4u_text--text">mdi-pencil-outline</v-icon>
        </v-btn>
      </template>

       <!---EDIT FORM --->
       <div class="editBook">
       <v-card>
         <v-card-text>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="8"
              >
                <v-text-field
                color="m4u_text"
                  label="Book Title"
                  required
                  v-model="bookData.BookTitle"
                ></v-text-field>
              </v-col>
              </v-row>
              <v-row></v-row>
              <v-col
                cols="12"
                sm="6"
                md="8"
              >
        <v-select
        color="m4u_text"
        v-model="CircleID"
        :items="circles"
        label="Share with..."
        item-text="CircleName"
        item-value="CircleID"
        return-object
        required
        ></v-select>
      </v-col>
      <v-row>
    <v-switch
      v-model="switch1"
      :label="'Is this a time capsule?'"
      @click="setUpDate()"
      color="m4u_text"
    ></v-switch>


            </v-row>
<!---TC Date Fields --->
<h3 v-if="switch1 === true" class="m4u_text--text">When do you want to release this time capsule?</h3> <br/>
 <v-row>
          <v-text-field
        v-if="switch1 === true"
        label="Year"
        required
        color="m4u_text"
        v-model="tcYear"
        type="number"
      ></v-text-field>
      
      <v-text-field
      v-if="switch1 === true"
        label="Month"
        required
        color="m4u_text"
        v-model="tcMonth"
        type="number"
      ></v-text-field>
      
      <v-text-field
      v-if="switch1 === true"
        label="Day"
        required
        color="m4u_text"
        v-model="tcDay"
        type="number"
      ></v-text-field>
 </v-row>
  </v-card-text>
       <!---END EDIT FORM --->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="editBook(book.BookID)"
          >
            Save Changes
          </v-btn>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="dialogedit = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
      </div>
    </v-dialog>

    
    <!---END OF EDIT DIALOG --->
<!---BEGINNING OF DELETE CONFIRMATION DIALOG --->
    <v-dialog
    v-if="book.BookOwner === user.UserID"
      v-model="dialogdelete"
      persistent
      max-width="25%"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          icon
        >
      <v-icon class="m4u_text--text">mdi-trash-can-outline</v-icon>
        </v-btn>
      </template>
      <v-card>
        <h3 class="m4u_text--text">
          Are you sure you want to delete "{{book.BookTitle}}"?
        </h3>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="deleteBook(book.BookID)"
          >
            Delete
          </v-btn>
          <v-btn
            class="teal--text text--accent-4"
            text
            @click="dialogdelete = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!---END OF DELETE CONFIRMATION DIALOG --->
        </v-card-text>

          <v-card-text v-for="memory in memories" :key="memory.StoryID">
            <div @click="goToMemoryReader(memory)" class="openReaderDiv">
       <h3 class="m4u_text--text" >{{memory.StoryTitle}}</h3>
            </div>
    </v-card-text>


      </v-card>
    </v-expand-transition>
  </v-card>
</div>
</template>
<script>

import EventService from '@/services/EventService.js'; 

export default {
  props: ["book"],

  
  computed: {
    user(){
      return this.$store.state.user
    }
  },

  data() {
    return {
      bookData: [],
      reveal: false,
      memories: [],
      dialogdelete: false,
      dialogedit: false,
      newBookTitle: '',
      switch1: false,
      dialogTC: false, 
      modalTC: false, 
      dateTC: '',
      tcYear: '',
      tcMonth: '',
      tcDay: '',
      circles: [],
      CircleID: ''

       }
    },

    created() {
          this.setTCswitch;
    },

    mounted() {

    this.getMyCircles(this.user.UserID);
    this.CircleID = this.book.CircleID;
    this.bookData = this.book;

  },

  methods: {

    async startEdit() {
            if(this.book.TimeCapsuleDate === null) {
        this.switch1 = false
      } else
      {
        this.switch1 = true;
        this.setUpDate();
      }
    },
    
    async getBookContent(bookID) {
      if(this.reveal === false) {
    this.reveal = true
    await (EventService.getBookContent(this.user.UserID, bookID))
      .then(
      (memories => {
        this.$set(this, "memories", memories);
      }).bind(this) 
    )
      } else {
        this.reveal=false
      }
    },

    async closeExpansion() {
      this.reveal = false
    },

    
    async goToMemoryReader(memory) {
      this.$store.dispatch('setStory', memory);
      this.$router.push({ name: 'memoryreader', params: { incomingStoryId: memory.StoryID } })
    },

    async deleteBook(bookID) {
    this.dialogdelete = false
    await (EventService.deleteBook(bookID, this.user.UserID))
      .then((newbooks) => {
        this.$emit('refresh', newbooks)
      }
        )
    },

    async editBook(bookID) {
    this.dialogedit = false
    if(!this.tcDate) {
      this.tcDate = null
    }

      if(this.book.TimeCapsuleDate !== null && this.switch1 === true) {
            if(this.tcMonth <10)  { this.tcMonth ='0'+ this.tcMonth } 
            if(this.tcDay <10)  { this.tcDay ='0'+ this.tcDay } 
      this.tcDate = this.tcYear + "-" + this.tcMonth + "-" + this.tcDay; 
          } 
            if(this.book.TimeCapsuleDate !== null && this.switch1 == false) {
        this.tcDate = null
      
          }
    await (EventService.editBook(this.user.UserID, this.book.BookID, this.bookData.BookTitle, this.tcDate, this.CircleID.CircleID))
      .then((newbooks) => {
        this.$emit('refresh', newbooks)
      }
        )
    },

    async getMyCircles() {
      // NEW - Use the eventService to call the getEvents() method
      await EventService.getMyCircles(this.user.UserID)
      .then(
        (circles => {
          this.$set(this, "circles", circles);
        }).bind(this)

      );
    },

    async setUpDate() {
      if(this.book.TimeCapsuleDate === null) {
              var dateObj = new Date();
      this.tcMonth = dateObj.getUTCMonth() + 1; //months from 1-12
      if(this.tcMonth <10)  { this.tcMonth ='0'+ this.tcMonth } 
      this.tcDay = dateObj.getUTCDate();
       if(this.tcDay <10)  { this.tcDay ='0'+ this.tcDay } 
      this.tcYear = dateObj.getUTCFullYear();
      this.tcDate = this.tcYear + "-" + this.tcMonth + "-" + this.tcDay; 
      }

      if(this.book.TimeCapsuleDate !== null) {
      const str = this.book.TimeCapsuleDate.toString()
      this.tcMonth = str.substr(5,2)
      this.tcDay = str.substr(8,2)
      this.tcYear = str.substr(0,4)
      this.tcDate = this.tcYear + "-" + this.tcMonth + "-" + this.tcDay; 
      }
      if(this.switch1 == false) {
        this.tcMonth = ''
        this.tcDay = ''
        this.tcYear = ''
        this.tcDate = ''
      }

    }

  }
};


</script>
<style lang="scss" scoped>

.card {
  max-height: 25%;
  background-position: center;
  background-size: cover;
  text-align: center;
}
.card-content {
  padding-top: 50px;
  margin-top: 200px;
  position: absolute;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.35);
  top: 0;
  padding: 10px;

  width: 100%;
  }

.editBook {
  max-width: "50%";
  padding: 5px;
}
.layout.row.wrap.mb-3 {
    background-color: white !important;
    justify-content: center;
}

  .feedMedia {
    height: 15em;
  }

  .imageTag {
    margin-top: 5px
  }

  .openReaderDiv {
    cursor: pointer;
    
  }

  .openReaderDiv:hover {
    background-color:lightgoldenrodyellow;
  }
  .storySummary {
    width: 80%;
    text-align: left;
    height: 20px;
    overflow: hidden;
  }

  .videoTag {
    width: 100%;
    margin-top: 5px;
  }

  span {
    font-size: 18px;
    text-align: center;
    width: 100%;
    position: absolute;
    bottom: 10px;
    right: 0;
  }
  h2 {
    margin-top: 10px;
  }


</style>